import { OrderDetailsStatus } from "./models";

export const ORDER_DETAIL_STATUSES: string[] = [
  OrderDetailsStatus.SUCCESS,
  OrderDetailsStatus.FAILED,
  OrderDetailsStatus.PENDING,
];
